import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { IonContent, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { OpenCarruselGalleriesComponent } from 'src/app/components/slider-galeries/components/open-carrusel-galleries/open-carrusel-galleries.component';
import { HttpService } from 'src/app/services/http.service';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-magazine',
  templateUrl: './magazine.page.html',
  styleUrls: ['./magazine.page.scss'],
})
export class MagazinePage implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('content') content: IonContent;
  private _domainId = environment.domainId;
  public page = 1;
  public search = '';
  public totalPages = undefined;
  public galleries: any[] = [];
  private _catalogueId = undefined;
  private _categoryId = undefined;
  public routeObs: Subscription = undefined;

  constructor(
    private httpSv: HttpService,
    private navCtrl: NavController,
    private route: ActivatedRoute,
    private _paramSv: ParamServicesService,
    private _uiSv: UiServices,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
  }

  ngAfterViewInit(): void {
    this.routeObs = this.route.queryParamMap.subscribe(
      async (params: ParamMap) => {
        this._catalogueId = params.get('id');
        this._categoryId = params.get('categoryId');
        await this.doSearch();
      }
    );
  }

  async doSearch() {
    try {
      const params = {
        pag: this.page,
        search: this.search,
        domainId: this._domainId,
        catalogueId: this._catalogueId || '',
        categoryId: this._categoryId || '',
        isActive: true,
      };
      const res: any = await this.httpSv.itemIndex('gallery', '', params);
      // this.httpSv.loadingIndicatorSrc.next(false);
      const data = res.data;
      this.totalPages = data.meta.last_page;
      this.galleries = data.data;
    } catch (err) {
      console.error(err);
    }
  }

  async upPage(page) {
    this.page = page;
    await this.doSearch();
    this.content.scrollToTop(500);
  }

  goGallery(gallery) {
    const galleryStyle = this._paramSv.styles.find(
      (x) => x.text === 'Slider de galerias '
    );
    if (galleryStyle && galleryStyle.selected === 'expandGalleryImage') {
      this._uiSv.showModal(
        OpenCarruselGalleriesComponent,
        {
          images: this.galleries,
          selected: gallery,
          typeImg: 'gallerie',
        },
        'carrusel-galleries'
      );
    } else {
      this.navCtrl.navigateForward(`gallery/${gallery.id}`);
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.routeObs.unsubscribe();
    }
  }
}
